import { render, staticRenderFns } from "./advisoryModal.vue?vue&type=template&id=a8f70c6e&scoped=true&"
import script from "./advisoryModal.vue?vue&type=script&lang=js&"
export * from "./advisoryModal.vue?vue&type=script&lang=js&"
import style0 from "./advisoryModal.vue?vue&type=style&index=0&id=a8f70c6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8f70c6e",
  null
  
)

export default component.exports